"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.regexp.split");




























































































































var _user = require("@/utils/user");
var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { tableData: [], // 列表数据
      droplist: [], imageSrcList: [], searchData: { // 入库单号
        instorageNo: '', // 设备类型编码
        deviceTypeCode: '', deviceTypeName: '', startTime: '', endTime: '', // 设备序列号
        sn: '', regionalId: '', // 当前页码
        page: 1, // 页码条数
        rows: 10 }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, // 表格列
      tableColumns: [{ prop: 'instorageNo', label: '入库单号', isShow: true }, { prop: 'sn', label: '设备序列号', isShow: true }, { prop: 'deviceTypeName', label: '设备型号名称', isShow: false }, { prop: 'deviceTypeCode', label: '工厂型号', isShow: true }, { prop: 'deviceTypeName', label: '营销型号', isShow: true }, { prop: 'createTime', label: '创建时间', formatter: _formatter.dateFormatter, isShow: false }, { prop: 'instorageTime', label: '入库时间', formatter: _formatter.dateFormatter, isShow: true }, { prop: 'auditStatus', label: '审核状态', formatter: _formatter.reviewFormatter, isShow: true }, { prop: 'auditTime', label: '审核时间', formatter: _formatter.dateFormatter, isShow: true }, { prop: 'auditUser', label: '审核人', isShow: true }, { prop: 'regionalName', label: '服务区域', isShow: true }, { prop: 'firmwareCenterVersion', label: '中心版本', isShow: true }, { prop: 'firmwareCommVersion', label: '通讯版本', isShow: false }, { prop: 'qrCode', label: '二维码地址', isShow: false }, { prop: 'ip', label: 'ip', isShow: false }, { prop: 'serverHost', label: '服务器地址', isShow: false }, { prop: 'serverPort', label: '服务器端口', isShow: false }, { prop: 'address', label: '位置', isShow: false }, { prop: 'updateTime', label: '更新时间', formatter: _formatter.dateFormatter, isShow: false }, {
        prop: 'remark',
        label: '备注',
        isShow: false },

      {
        prop: 'operatorUser',
        label: '操作人',
        isShow: false }],


      regionList: [] };

  },
  mounted: function mounted() {
    var self = this;
    self.init();
    self.fetchRegionList();
    self.getdrop();
  },
  methods: {
    /**
              * 获取区域列表
              */
    fetchRegionList: function fetchRegionList() {var _this = this;
      this.getData('/api/faServicesRegional/getAll', { page: 1, rows: 9999999 }, function (res) {
        _this.regionList = res.list;
      });
    },
    init: function init() {
      var self = this;
      self.getData('/api/faDeviceInfo', self.searchData, function (res) {
        self.tableData = res.list;
        self.pageData.page = res.pageNum;
        self.pageData.total = res.total;
      });
    },
    checkPermission: _user.checkPermission,
    // 设置imageList
    setImageList: function setImageList(val) {
      var arr = [];
      if (val) {
        arr.push(val);
      }
      this.imageSrcList = arr;
    },
    resetFun: function resetFun() {// 重置
      this.searchData.instorageNo = '';
      this.searchData.deviceTypeCode = '';
      this.searchData.sn = '';
      this.searchData.startTime = '';
      this.searchData.endTime = '';
      this.searchData.regionalId = '';
      this.init();
    },
    searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;
      var start = new Date(this.searchData.startTime);
      var deliverTimeStart = start.getTime();
      var end = new Date(this.searchData.endTime);
      var deliverTimeEnd = end.getTime();
      if (deliverTimeStart > deliverTimeEnd) {
        this.$message({
          message: '请选择结束时间要大于开始时间',
          type: 'error' });

        this.searchData.endTime = '';
        return false;
      }
      if (this.searchData.endTime) {
        var endTime = this.searchData.endTime;
        if (endTime.split(' ').length < 2) {
          endTime = endTime + ' 23:59:59';
          this.searchData.endTime = endTime;
        }
      }
      this.init();
    },

    handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.init();
    },
    handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;
      this.init();
    },
    changeisForceFun: function changeisForceFun(val) {
      var self = this;
      self.searchData.type = '';
      if (val === '1') {
        self.searchData.type = '1';
      } else if (val === '2') {
        self.searchData.type = '2';
      }
    },
    changeisForceFun2: function changeisForceFun2(val) {
      var self = this;
      self.addData.type = '';
      if (val === '1') {
        self.addData.type = '1';
      } else if (val === '2') {
        self.addData.type = '2';
      }
    },
    getFile: function getFile(event) {
      this.addData.imageFile = event.target.files[0];
    },
    getdrop: function getdrop() {
      var self = this;
      self.getData('/api/faDeviceType/getDownList', {}, function (res) {
        self.droplist = res;
      });
    },
    imgPreview: function imgPreview(file) {
      var self = this;
      // 看支持不支持FileReader
      if (!file || !window.FileReader) return;

      if (/^image/.test(file.type)) {
        // 创建一个reader
        var reader = new FileReader();
        // 将图片将转成 base64 格式
        reader.readAsDataURL(file);
        // 读取成功后的回调
        reader.onloadend = function () {
          self.addData.imageFile = this.result;
        };
      }
    },
    onfileChange: function onfileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.newimg = files[0];
      this.imgPreview(files[0]);
    } } };exports.default = _default;